module.exports = __webpack_public_path__ + "img/bg.eb399bff.png";